import React, { useEffect, useState } from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

const option = [
    { label: "پرفروش ترین", value: "sell" },
    { label: "جدیدترین ها", value: "new" },
    { label: "محبوب ترین ها", value: "popular" },
    { label: "گران ترین ها", value: "up" },
    { label: "ارزان ترین ها", value: "down" },
];

const SortProduct = ({ url }: { url: string }) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const sort = searchParams.get("sort");
    const [selectedSort, setSelectedSort] = useState('sell');

    const pattern = /[?&]sort=[^&]*(&|$)/i;
    const pattern2 = /[?&]page=\d+(&|$)/i;


    const handleChange = (b: any) => {
        router.push(`${pathname}?page=1${url.replace(pattern, "").replace(pattern2, "")}&sort=${b}`);
    };

    useEffect(() => {
        if (sort) {
            const values: any = option.find((i) => i.value === sort)?.value;
            setSelectedSort(values);
        }
    }, [sort]); 

    return (
        <Select value={selectedSort} onValueChange={(e) => handleChange(e)}>
            <SelectTrigger style={{ direction: "rtl" }} className="w-[160px]">
                <SelectValue />
            </SelectTrigger>
            <SelectContent style={{ direction: "rtl" }}>
                <SelectGroup>
                    {option.map((i) => (
                        <SelectItem key={i.value} value={i.value}>{i.label}</SelectItem>
                    ))}
                </SelectGroup>
            </SelectContent>
        </Select>
    );
};

export default SortProduct;
